import moment, { Moment } from 'moment';
import React from 'react';

import { FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DateTimePicker } from '@material-ui/pickers';

const useStyles = makeStyles((theme) => ({
  formControlLabel: {
    color: theme.palette.darkGray.main,
    fontSize: '16px',
    lineHeight: '20px',
    marginBottom: '6px',
    fontWeight: 600,
  },
}));

interface Props {
  name: string;
  id?: string;
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
  minDate: Moment;
  maxDate?: Moment;
  error: boolean;
  helperText?: string;
}

const CustomTouchDateTimePicker: React.FC<Props> = ({
  name,
  id,
  value,
  onChange,
  onClose,
  minDate,
  maxDate,
  error,
  helperText,
}) => {
  const classes = useStyles();

  return (
    <FormControl fullWidth>
      <div className={classes.formControlLabel}>
        Send On
      </div>
      <DateTimePicker
        id={id ?? name}
        name={name}
        views={['date', 'hours']}
        minutesStep={60}
        inputVariant="outlined"
        value={value ? moment(value) : null}
        onChange={(nextValue) => onChange(nextValue ? moment(nextValue).toISOString() : '')}
        onClose={onClose}
        disablePast
        minDate={minDate}
        maxDate={maxDate}
        format="MMMM Do YYYY, h:mm a"
        fullWidth
        error={error}
        helperText={helperText}
        FormHelperTextProps={{ style: { marginLeft: 0, marginRight: 0 } }}
      />
    </FormControl>
  );
};

export default CustomTouchDateTimePicker;
